import styled from 'styled-components';

export const CardIcon = styled.div<{ $color: string }>`
  width: 54px;
  height: 54px;
  border-radius: 10px;
  background-color: ${({ $color }) => $color};
  display: flex;
  justify-content: center;
  align-items: center;
`;
